import { render, staticRenderFns } from "./sidebar-section.vue?vue&type=template&id=0a343c48&scoped=true"
import script from "./sidebar-section.vue?vue&type=script&lang=js"
export * from "./sidebar-section.vue?vue&type=script&lang=js"
import style0 from "./sidebar-section.vue?vue&type=style&index=0&id=0a343c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a343c48",
  null
  
)

export default component.exports